import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/**
 * QR Code display for kiosk mode.
 * When a user selects a room and time on the kiosk, this generates a QR code
 * containing a deep link. The user scans it with their phone, authenticates
 * via M365 SSO, and confirms the booking.
 */
export default function QRBooking({ bookingDetails, baseUrl, onClose }) {
  const [qrSvg, setQrSvg] = useState('');
  const [countdown, setCountdown] = useState(120); // 2-minute expiry

  // Build the booking URL with parameters
  const bookingUrl = `${baseUrl}/book?` + new URLSearchParams({
    room: bookingDetails.roomId,
    date: bookingDetails.date,
    start: bookingDetails.startTime,
    end: bookingDetails.endTime,
    subject: bookingDetails.subject || '',
    src: 'kiosk',
  }).toString();

  useEffect(() => {
    // Generate QR code using the qrcode-svg approach (inline SVG)
    generateQR(bookingUrl).then(svg => setQrSvg(svg));
  }, [bookingUrl]);

  // Countdown timer
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          onClose?.();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [onClose]);

  const minutes = Math.floor(countdown / 60);
  const seconds = countdown % 60;

  return (
    <div className="qr-booking-overlay">
      <div className="qr-booking-modal">
        <h2>Scan to Book</h2>
        <p className="qr-instructions">
          Scan this QR code with your phone to complete the booking.
          You'll be asked to sign in with your SSP account.
        </p>

        <div className="qr-details">
          <p><strong>{bookingDetails.roomName}</strong></p>
          <p>{new Date(bookingDetails.date + 'T12:00:00').toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })}</p>
          <p>{bookingDetails.startTime} - {bookingDetails.endTime}</p>
        </div>

        <div
          className="qr-code"
          dangerouslySetInnerHTML={{ __html: qrSvg }}
        />

        <div className="qr-timer">
          Expires in {minutes}:{seconds.toString().padStart(2, '0')}
        </div>

        <button className="qr-cancel-btn" onClick={onClose}>
          Cancel
        </button>
      </div>
    </div>
  );
}

/**
 * Generate an SVG QR code using the 'qrcode' npm package.
 */
async function generateQR(text) {
  try {
    const svg = await QRCode.toString(text, { type: 'svg', width: 256, margin: 2 });
    return svg;
  } catch (err) {
    console.error('QR generation failed:', err);
    return `<svg xmlns="http://www.w3.org/2000/svg" width="256" height="256" viewBox="0 0 256 256">
      <rect width="256" height="256" fill="#fff" stroke="#333" stroke-width="2" rx="8"/>
      <text x="128" y="120" text-anchor="middle" font-size="14" fill="#333">QR Code Error</text>
      <text x="128" y="145" text-anchor="middle" font-size="10" fill="#666">${err.message || 'Generation failed'}</text>
    </svg>`;
  }
}
